module.exports = __webpack_public_path__ + "img/20180815_150119_065.51de8758.jpg";